"use client";
import {
  createElement,
  createHook,
  forwardRef
} from "./LMDWO4NN.js";
import {
  __objRest,
  __spreadValues
} from "./3YLGPPWQ.js";

// src/separator/separator.tsx
var TagName = "hr";
var useSeparator = createHook(
  function useSeparator2(_a) {
    var _b = _a, { orientation = "horizontal" } = _b, props = __objRest(_b, ["orientation"]);
    props = __spreadValues({
      role: "separator",
      "aria-orientation": orientation
    }, props);
    return props;
  }
);
var Separator = forwardRef(function Separator2(props) {
  const htmlProps = useSeparator(props);
  return createElement(TagName, htmlProps);
});

export {
  useSeparator,
  Separator
};
